import React from 'react'
import {Box, Skeleton, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import moment from 'moment'
import {useAccountStyle} from '@containers/accountStyle/hooks/useAccountStyle'
import {IDashboardInfo} from '@containers/dashboard/types'

interface IProps {
	info?: IDashboardInfo
}

const greetingKey = () => {
	const hour = new Date().getHours()
	if (hour < 12) return 'dashboardPage.greetingMorning'
	if (hour < 18) return 'dashboardPage.greetingDay'
	return 'dashboardPage.greetingEvening'
}

const WelcomeBanner = ({info}: IProps) => {
	const {t} = useTranslation()
	const {tokens} = useAccountStyle()

	return (
		<Box
			sx={{
				gridColumn: '1 / -1',
				borderRadius: '12px',
				padding: '16px 20px',
				background: tokens.panelBackground,
				color: tokens.text,
			}}
		>
			<Stack direction={{xs: 'column', sm: 'row'}} justifyContent={'space-between'} gap={1}>
				<Box>
					<Typography variant={'body2'} sx={{opacity: .8}}>{t(greetingKey())}</Typography>
					<Typography variant={'h6'} fontWeight={600}>
						{info ? info.userName : <Skeleton width={160}/>}
					</Typography>
					{info && <Typography variant={'body2'} sx={{opacity: .8}}>
						{t('dashboardPage.withUs', {duration: info.duration})}
						{' · '}
						{t('dashboardPage.accountSince', {date: moment(info.dateAccountStart, 'YYYY/MM/DD').format('DD.MM.YYYY')})}
					</Typography>}
				</Box>
				<Typography variant={'body2'} sx={{opacity: .85, textAlign: {sm: 'right'}}}>
					{info && <>IP {info.userIp}<br/></>}
					{moment().format('DD.MM.YYYY HH:mm')}
				</Typography>
			</Stack>
		</Box>
	)
}

export default WelcomeBanner
